import { authFetch } from "~/services/fetch";

interface deviceSetOnMissionProps {
  readonly deviceId: number;
  readonly onMissionReasonId: number;
  readonly comment: string;
}

export async function deviceSetOnMission({ deviceId, onMissionReasonId, comment }: deviceSetOnMissionProps) {
  const response = await authFetch({
    method: 'POST',
    url: '/device/set-on-mission',
    data: {
      device_id: deviceId,
      on_mission_reason_id: onMissionReasonId,
      comment: comment
    }
  })

  return response
}

export async function getOnMissionReason() {
  const response = await authFetch({
    url: '/on-mission-reason',
    method: 'GET',
  })

  return response.data;
}